import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";

const EASE = [0.16, 1, 0.3, 1];

export const Manifesto = () => {
  const { lang, t } = useLanguage();

  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative bg-[#0A0A0A] py-28 md:py-40"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mb-20 flex items-center gap-4"
        >
          <span className="h-px w-12 bg-[#C5A059]" />
          <span className="font-manrope text-xs font-semibold uppercase tracking-[0.22em] text-[#C5A059]">
            {t.manifesto.kicker}
          </span>
        </motion.div>

        <div className="border-t border-[#2A2A2A]">
          {t.manifesto.chapters.map((c, i) => (
            <motion.div
              key={`${lang}-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, delay: i * 0.1, ease: EASE }}
              className="group grid grid-cols-1 gap-6 border-b border-[#2A2A2A] py-14 transition-colors duration-500 hover:bg-[#0D0D0D] md:grid-cols-12 md:gap-10 md:py-20"
            >
              <div className="md:col-span-3">
                <span className="text-stroke-gold font-bebas text-7xl leading-none transition-all duration-500 md:text-9xl">
                  {c.n}
                </span>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-cormorant text-3xl italic text-[#F5F5F5] md:text-4xl">
                  {c.title}
                </h3>
              </div>
              <div className="md:col-span-5">
                <p className="max-w-md font-manrope text-sm leading-relaxed text-[#8A9199] md:text-base">
                  {c.text}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
